import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Footer from "../components/Footer";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is an online clipboard?",
      answer: (
        <>
          An online clipboard is a free web-based tool that lets you store and share text between devices instantly, no login or software required. Simply paste your text, get a code, and retrieve it from any device using{" "}
          <a href="https://online-clipboard.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Online-Clipboard.in
          </a>.
        </>
      ),
    },
    {
      question: "How can I share text online using an online clipboard?",
      answer: (
        <>
          Just visit{" "}
          <a href="https://online-clipboard.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Online-Clipboard.in
          </a>, paste or type your text, click Generate Code, and share that code with anyone. The receiver enters the code to instantly retrieve the text on their device.
        </>
      ),
    },
    {
      question: "What is the best online clipboard available for free?",
      answer: (
        <>
          <a href="https://online-clipboard.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Online-Clipboard.in
          </a>{" "}
          is one of the best online clipboards available. It's completely free, fast, and works across all devices without needing any account or installation.
        </>
      ),
    },
    {
      question: "Is this clipboard online tool really free to use?",
      answer: (
        <>
          Yes!{" "}
          <a href="https://online-clipboard.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Online-Clipboard.in
          </a>{" "}
          is 100% free. There are no hidden charges, no subscriptions, and no sign-up required.
        </>
      ),
    },
    {
      question: "What makes this a free online clipboard compared to others?",
      answer: (
        <>
          Unlike many tools that limit features behind a paywall,{" "}
          <a href="https://online-clipboard.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Online-Clipboard.in
          </a>{" "}
          gives you full access, generate codes, share text, and retrieve content without spending a penny.
        </>
      ),
    },
    {
      question: "How does online clipboard sharing work between two devices?",
      answer:
        "It's simple. PC1 adds text to the online clipboard and generates a unique code. PC2 enters that code on the same website to retrieve the exact text. No cable, no Bluetooth, no hassle.",
    },
    {
      question: "Can I use this online clipboard to share text online for free?",
      answer: (
        <>
          Absolutely!{" "}
          <a href="https://online-clipboard.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Online-Clipboard.in
          </a>{" "}
          is designed specifically to let anyone share text online free of cost.
        </>
      ),
    },
    {
      question: "Is there a limit to how much text I can share online using this tool?",
      answer:
        "Online-Clipboard.in supports sharing a generous amount of text, making it suitable for notes, code snippets, links, and more.",
    },
    {
      question: "Do I need to create an account to use this online clipboard?",
      answer: (
        <>
          No account needed!{" "}
          <a href="https://online-clipboard.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
            Online-Clipboard.in
          </a>{" "}
          works without any registration.
        </>
      ),
    },
    {
      question: "Is it safe to share text online using Online-Clipboard.in?",
      answer:
        "Yes, your shared text is tied to a unique random code that only the person with the code can access.",
    },
  ];

  return (
    <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6 transition-colors duration-300">
      <div className="max-w-6xl mx-auto">

        {/* TITLE */}
        <h2 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
          Frequently Asked Questions
        </h2>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-card dark:bg-cardDark rounded-2xl p-6 border border-borderLight dark:border-borderDark transition-all duration-300"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex justify-between items-center text-left"
              >
                <span className="text-lg md:text-xl font-semibold text-titleLight dark:text-titleDark">
                  {faq.question}
                </span>

                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`text-titleLight dark:text-titleDark text-xl transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""
                    }`}
                />
              </button>

              {openIndex === index && (
                <div className="mt-4 text-textMain dark:text-textDark leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </section>
  );
}